<template>	
	<div class="bg-container">
		<div class="bg">
			<img class="title" src="@/assets/image/loading/title.png" />
			<div class="flexCenter column txt_white main_section">
				<div>{{ $t('app.name') }}</div>
				<div class="flexCenter">
					<StarRating
						v-model="app.starNum"
						:max-rating="app.maxStar"
						:read-only="true"
					></StarRating>
				</div>
				<div style="margin-top: 0.7rem">
					{{
						$t('app.evaluation', {
							star_num: app.starNum,
							comment_num: Math.round(app.commentNum / 10000)
						})
					}}
				</div>
			</div>
			<div class="flexCenter column">
				<div class="app_btn" @click="redirect()">
					{{ $t('redirect.launch_app') }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import UAParser from 'ua-parser-js'
import { mapActions } from 'vuex'
import StarRating from '@/components/basic/rating'

export default {
	components: {
		StarRating
	},
	data() {
		return {
			app: {
				maxStar: 5,
				starNum: 0,
				commentNum: 0
			},
			redirectToStore: (this.$route.query.redirect_to_store === 'true') || false,
			redirectTo: this.$route.query.redirect || '/member/index',
			redirectTimes: this.$route.query.redirect_times || 0,
			stopReload: this.$route.query.stopReload || false,
			uaParser: undefined
		}
	},
	created: function () {
		UAParser.prototype.isTablet = function () {
			return this.getDevice().type === 'tablet'
		}

		UAParser.prototype.isMobile = function () {
			return this.getDevice().type === 'mobile'
		}

		UAParser.prototype.iOS = function () {
			return this.getOS().name === 'iOS'
		}

		UAParser.prototype.android = function () {
			return this.getOS().name === 'Android'
		}

		UAParser.prototype.inAppWebView = function () {
			return this.getBrowser().name === 'Goferbro'
		}

		this.uaParser = new UAParser({
			browser: [
				[/(Goferbro)\/(\d.\d.\d)/],
				[UAParser.BROWSER.NAME, UAParser.BROWSER.VERSION]
			]
		})

		this.fetchConfig()
			.then((res) => {
				const data = res.result.config_list
				this.app = Object.assign(
					{},
					{
						starNum: parseInt(data.mobile_star_num),
						commentNum: parseInt(data.mobile_comment_num),
						google_play_url: data.mobile_google_play_url,
						app_store_url: data.mobile_app_store_url
					}
				)

				if (this.app.google_play_url === '' || this.app.app_store_url === '') {
					console.warn('未設置 App Store URL');
					this.$alert.warning('請至商店下載 App')
					return;
				}


				if (process.env.NODE_ENV !== 'production') {
					return this.$alert.warning(
						this.$t('redirect.redirect_app_only_in_production')
					)
				}

				// 當有附加參數則自動跳轉至 app store / google play
				if (this.redirectToStore) {
					if (this.uaParser.iOS()) {
						return window.location.replace(this.app.app_store_url)
					} else if (this.uaParser.android()) {
						return window.location.replace(this.app.google_play_url)
					}
				}

				if (this.redirectTimes <= 1) {
					this.redirect()
				}
			})
			.catch((err) => {
				console.error(err)
			})
	},
	methods: {
		...mapActions(['fetchConfig']),
		redirect: function () {
			// if (!this.uaParser.isTablet() && !this.uaParser.isMobile()) {
			// 	return window.location.replace(process.env.VUE_APP_SITE_URL)
			// }

			// 若是已載入在 app 中，則依 redirect 路徑導向
			if (this.uaParser.inAppWebView()) {
				this.$router.push({
					name: this.redirectTo,
					query: this.$route.query
				})
				return window.location.replace(process.env.VUE_APP_H5_HOST + this.$route.fullPath)
			}

			/**
			 * 先跳轉一次檢查是否能正常開啟 App
			 * 倘若不行則表示未安裝或是未檢測到，則跳轉商店
			 */
			if (this.redirectTimes === 0) {
				const query = Object.assign(
					{
						redirect_times: 1
					},
					this.$route.query
				)
				this.$router.push({ name: 'Startapp', query: query })
				return window.location.reload()
			}

			if (this.uaParser.iOS()) {
				return window.location.replace(this.app.app_store_url)
			} else if (this.uaParser.android()) {
				return window.location.replace(this.app.google_play_url)
			}

			return this.$alert.warning(this.$t('redirect.detect_device_os_failure'))
		}
	}
}
</script>

<style scoped>
.bg-container {
	display:flex;
	justify-content:center;
	align-items:center;
	height:100%;
	min-width:360px;
}

.bg {	
	background-image: url('~@/assets/image/loading/loading.png');
	background-repeat: no-repeat;
	background-size: 100%;
	width: 100%;
	height:100%;
	max-width: 420px;
	max-height: 900px;
	text-align: center;
	font-family: '微軟正黑體';
}
.flexCenter {
	display: flex;
	justify-content: center;
	align-items: center;
}
.column {
	flex-direction: column;
}
.app_btn {
	background: #f2c121;
	width: 85%;
	padding: 18px 0px;
	font-size: 0.9rem;
	margin: 1.5rem 0rem 0.7rem;
}
.title {
	max-width: 420px;
	width: 93%;
	margin-top: 3rem;
}
.txt_white {
	color: white;
}
.main_section {
	margin-top: 14.5rem;
	line-height: 2rem;
	font-size: 0.8rem;
}
.star {
	margin: 0px 2px;
}
.browser {
	font-size: 0.7rem;
}
</style>